module.exports = __webpack_public_path__ + "img/OpenFBA-Sticker.5bca8085.svg";